<template>
  <div class="layout layout--giftcard">
    <Body :class="`tpl-${template}`" />

    <a
      class="visually-hidden"
      href="#main"
    >
      {{ $t('Skip to content') }}
    </a>

    <AppNotification class="container" />

    <AppHeader class="layout__header" />

    <main class="layout__main">
      <slot />
    </main>

    <AppFooter class="layout__footer" />
  </div>
</template>

<script setup lang="ts">
const template = ref('giftcard')
provide('template', template)

const step = ref(1)
provide('step', step)
</script>

<style src="~layers/app/layouts/default.css" />
